import * as R from 'ramda';
import { graphqlQuery } from './GraphqlUtils';
import {
  CreateCustomerCompanyVersionInput,
  VersionBytenantLandscapeAndApplyDateTimeQuery,
  VersionBytenantLandscapeAndApplyDateTimeQueryVariables,
} from '@/API';
import { versionBytenantLandscapeAndApplyDateTime } from '@/graphql/queries';

const fetchCustomerCompanyVersions = async (
  tenantLandscape: string
): Promise<CreateCustomerCompanyVersionInput[]> => {
  const versions: CreateCustomerCompanyVersionInput[] = [];
  let isFirst = true;
  let nextToken: string | undefined | null = null;

  while (isFirst || nextToken) {
    isFirst = false;
    const result = await graphqlQuery<
      VersionBytenantLandscapeAndApplyDateTimeQuery,
      VersionBytenantLandscapeAndApplyDateTimeQueryVariables
    >(versionBytenantLandscapeAndApplyDateTime, { tenantLandscape });

    const versionItems:
      | CreateCustomerCompanyVersionInput[]
      | undefined = R.path(
      ['versionBytenantLandscapeAndApplyDateTime', 'items'],
      result
    );
    if (versionItems) {
      versions.push(...versionItems);
    }
    nextToken = R.path(
      ['versionBytenantLandscapeAndApplyDateTime', 'nextToken'],
      result
    );
  }
  return versions;
};

const sortByApplyDateTime: (
  xs: CreateCustomerCompanyVersionInput[]
) => CreateCustomerCompanyVersionInput[] = R.sortBy(R.prop('applyDateTime'));

export const fetchLatestCustomerCompanyVersion = R.pipe(
  fetchCustomerCompanyVersions,
  R.andThen(sortByApplyDateTime),
  R.andThen(R.last),
  R.andThen(
    R.path<string>(['version'])
  )
);
